import React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import checked from "../../img/checked.svg";
import checkedDisabled from "../../img/checked-disabled.svg";
import cancel from "../../img/cancel.svg";
import cancelDisabled from "../../img/cancel-disabled.svg";
import loading from "../../img/loading.svg";

class AddRdvType extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      empty: true,
      loading: false,
      label: "",
      isPublic: false,
      duration: "",
      message: ""
    };
  }

  handleLabel = event => {
    this.setState(
      {
        label: event.target.value
      },
      this.handleChange
    );
  };

  handleDuration = event => {
    this.setState(
      {
        duration: event.target.value
      },
      this.handleChange
    );
  };
  handleMessage = event => {
    this.setState(
      {
        message: event.target.value
      },
      this.handleChange
    );
  };
  handleIsPublic = event => {
    this.setState(
      {
        isPublic: event.target.checked
      },
      this.handleChange
    );
  };

  handleChange = () => {
    if (this.state.label.length < 1 || this.state.duration.length < 1) {
      this.setState({
        empty: true
      });
    } else {
      this.setState({
        empty: false
      });
    }
  };
  handleSave = async () => {
    // redirect if no user is logged in
    /*  if (!this.props.loggedInUserQuery.loggedInUser) {
        console.warn("only logged in users can create new posts");
        return;
      }*/

    const { label, isPublic, message } = this.state;
    //    const authorId = this.props.loggedInUserQuery.loggedInUser.id;
    const role = isPublic ? "PUBLIC" : "SECRETARY";
    this.setState({
      loading: true
    });
    const name = label;
    const duration = parseInt(this.state.duration, 10);
    const infos = message;
    const doctorId = this.props.doctorId;
    const index = this.props.index;
    await this.props
      .createSlotTypeMutation({
        variables: { name, duration, role, infos, doctorId, index }
      })
      .then(resp => {
        this.props.refetch();
      })
      .catch(e => {
        console.error("Addrdvtype", e);
      });
    this.setState({
      loading: false,
      label: "",
      isPublic: false,
      duration: "",
      message: "",
      empty: "true"
    });
    //  this.props.history.replace("/");
  };
  handleCancel = () => {
    this.setState({
      label: "",
      isPublic: false,
      duration: "",
      message: "",
      empty: "true"
    });
  };
  render() {
    let save = this.state.empty ? (
      <figure className="image is-32x32">
        <img alt="checkedDisabled" src={checkedDisabled} />
      </figure>
    ) : (
      <figure onClick={this.handleSave} className="image is-32x32">
        <img alt="checked" src={checked} />
      </figure>
    );
    let cancelbtn = this.state.empty ? (
      <figure className="image is-32x32">
        <img alt="cancelDisabled" src={cancelDisabled} />
      </figure>
    ) : (
      <figure onClick={this.handleCancel} className="image is-32x32">
        <img alt="cancel" src={cancel} />
      </figure>
    );
    if (this.state.loading) {
      save = (
        <figure className="image is-32x32">
          <img alt="loading" src={loading} />
        </figure>
      );
    }

    return (
      <tr>
        <td />
        <td>
          <input
            className="input"
            placeholder="libellé"
            onChange={this.handleLabel}
            value={this.state.label}
          />
        </td>
        <td>
          <label className="checkbox">
            <input
              type="checkbox"
              onChange={this.handleIsPublic}
              checked={this.state.isPublic ? true : false}
            />
          </label>
        </td>
        <td>
          <input
            className="input"
            placeholder="1"
            onChange={this.handleDuration}
            value={this.state.duration}
          />
        </td>
        <td>
          <textarea
            className="input"
            placeholder="infos"
            onChange={this.handleMessage}
            value={this.state.message}
          />
        </td>
        <td>
          {save} {cancelbtn}
        </td>
      </tr>
    );
  }
}

const CREATE_RDVTYPE_MUTATION = gql`
  mutation CreateSlotTypeMutation(
    $name: String!
    $duration: Int!
    $infos: String
    $role: Role
    $doctorId: ID!
    $index: Int
  ) {
    createSlotType(
      name: $name
      duration: $duration
      infos: $infos
      role: $role
      doctorId: $doctorId
      index: $index
    ) {
      id
    }
  }
`;

export default graphql(CREATE_RDVTYPE_MUTATION, {
  name: "createSlotTypeMutation"
})(AddRdvType);



// WEBPACK FOOTER //
// ./src/components/utilities/AddRdvType.js